import React from "react";
import Dropdown from "app/components/Dropdown";
import MemberProfile from "app/components/MemberProfile";
import { CheckIcon } from "app/components/Icons";
import { TicketType } from "../containers/Boards/types";
import { useSelector } from "react-redux";
import { selectTicketTypes } from "app/redux/selector";
import { getTicketIcon } from "../containers/Boards/containers/Home/containers/helpers";
import { ITicketTypes } from "app/types";

interface CustomProps {
  value?: string;
  setValue?: (value: ITicketTypes) => void;
  trigger: React.ReactNode;
  align?: "start" | "end" | "center";
  isHeader?: string;
  className?: string;
  isHeaderClassName?: string;
  showEndIcon?: boolean;
  showDefault?: boolean;
  setOpen?:() => void;
  dropDownClassName?: string;
  isUnPaddedY?: boolean;
    onOpen?: () => void;
  onClose?: () => void;
}

const CommonTicketTypeSelection: React.FC<CustomProps> = ({
  setValue,
  value,
  trigger,
  align = "center",
  isHeader,
  className,
  isHeaderClassName,
  showEndIcon,
  showDefault,
  setOpen,
  dropDownClassName,
  isUnPaddedY = false,
   onOpen,
  onClose,
}) => {
  const data = useSelector(selectTicketTypes);
  const MenuItems = data?.map((ele) => {
    if (ele)
      return {
        label: (
          <div
            className={`flex gap-2 w-[100%] min-h-[50px] items-center justify-between`}
          >
            <div className="flex items-center gap-3">
            <div className="min-w-[20px]">
              <img
                src={getTicketIcon(ele?.icon as TicketType)}
                alt="task-icon"
                className="size-[24px]"
              />
            </div>

            <div
              className={`${
                ele?.icon === TicketType?.TASK
                  ? " font-medium "
                  : " font-normal "
              } text-sm leading-[18px] text-secondary truncate`}
            >
              {ele?.name}
              {showDefault && (
                <span className="ps-2 text-[#BDC0C3] text-xs font-normal leading-[18px]">
                  {ele?.icon === TicketType?.TASK && "(Default)"}
                </span>
              )}
            </div>
           </div>
            {/* Right Section: Custom or hour and date show */}
            {showEndIcon && <>
              { ele?._id ===value &&  <CheckIcon color="#5A8DF1" />}</>}
          </div>
        ),
        action: () => {
          setValue && setValue(ele);
        },
        isUnPaddedY: isUnPaddedY  
      };
    else return { label: "", action: () => {} };
  });
  return (
    <>
      <Dropdown
        setOpen={setOpen}
        trigger={trigger}
        projectInfoIcon={
          <div className="flex flex-col gap-2">
            {isHeader && (
              <div
                className={`${isHeaderClassName}  flex items-center justify-between px-4 py-2 text-secondary tracking-[0.56px] text-sm font-semibold leading-[21px] uppercase `}
              >
                <span>{isHeader}</span>
              </div>
            )}
          </div>
        }
        menuItems={MenuItems ? MenuItems : []}
        align={align}
        className={`${className} py-1`}
        dropDownClassName={dropDownClassName}
         onOpen={onOpen}
      onClose={onClose}
      />
    </>
  );
};

export default CommonTicketTypeSelection;
